module.exports = __webpack_public_path__ + "static/img/day-3.889e86c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/day-3.png
// module id = 0hjo
// module chunks = 1